import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { FuseNavigationModule } from './../../../../../../@fuse/components/navigation/navigation.module';
import { FuseSharedModule } from './../../../../../../@fuse/shared.module';

import { NavbarVerticalStyle2Component } from './style-2.component';
import { AvatarModule } from 'ngx-avatars';
import { TranslateModule } from '@ngx-translate/core';
import { PortalModule } from '@angular/cdk/portal';
@NgModule({
    declarations: [
        NavbarVerticalStyle2Component
    ],
    imports     : [
        TranslateModule.forChild(),
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        AvatarModule,
        FuseSharedModule,
      FuseNavigationModule,
      PortalModule
    ],
    exports     : [
        NavbarVerticalStyle2Component
    ]
})
export class NavbarVerticalStyle2Module
{
}
